import React, { useState, useEffect, useRef } from "react";
import { getInsuranceAds } from "../../../actions/dashboardActionsPP";
import { useSelector, useDispatch } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { Button } from "cxa-components";
import Modal from "react-modal";
import messages from "components/messagesDescription";
import LeftIcon from "../../../assets/images/svg/ic_chevron_left_24px.svg";
import RightIcon from "../../../assets/images/svg/ic_chevron_right_24px.svg";

const InsuranceAdsPP = ({ intl }) => {
  const [insuranceAdsIndex, setInsuranceAdsIndex] = useState(0);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [autoScrollPaused, setAutoScrollPaused] = useState(false);
  const descriptionRef = useRef(null);

  const dispatch = useDispatch();

  const insuranceAdsData = useSelector(state => {
    if (state && state.dashboardPP && state.dashboardPP.insuranceAdsData) {
      return state.dashboardPP.insuranceAdsData.advertisementList || [];
    }
    return [];
  });

  useEffect(() => {
    dispatch(getInsuranceAds());
  }, [dispatch]);

  useEffect(() => {
    let timer;
    if (!autoScrollPaused) {
      timer = setTimeout(() => {
        goToNextMessage();
      }, 10000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [insuranceAdsIndex, insuranceAdsData, autoScrollPaused]);

  useEffect(() => {
    checkOverflow();
  }, [insuranceAdsIndex, insuranceAdsData]);

  const checkOverflow = () => {
    if (descriptionRef.current) {
      setIsOverflowing(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
    }
  };

  const goToPreviousMessage = () => {
    if (insuranceAdsData.length > 0) {
      setInsuranceAdsIndex(
        prevIndex => (prevIndex - 1 + insuranceAdsData.length) % insuranceAdsData.length
      );
    }
  };

  const goToNextMessage = () => {
    if (insuranceAdsData.length > 0) {
      setInsuranceAdsIndex(prevIndex => (prevIndex + 1) % insuranceAdsData.length);
    }
  };

  const handleDotClick = index => {
    setInsuranceAdsIndex(index);
  };

  const handleReadMore = e => {
    e.preventDefault();
    setModalIsOpen(true);
    setAutoScrollPaused(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setAutoScrollPaused(false);
  };

  if (insuranceAdsData.length === 0) {
    return null;
  }

  const currentAd = insuranceAdsData[insuranceAdsIndex];

  const InsuranceAdModal = (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className="message-board-modal"
      overlayClassName="message-board-modal-overlay"
    >
      <button onClick={closeModal} className="link message-board-modal-close">
        &times;
      </button>
      <div>
        <div>
          <img alt={currentAd.title} src={currentAd.imageURL} />
        </div>
        <div>
          <strong dangerouslySetInnerHTML={{ __html: currentAd.title }} />
          <div
            className="message-board-modal-description"
            dangerouslySetInnerHTML={{ __html: currentAd.description }}
          />
          <Button href={currentAd.productURL} target="_blank" rel="noopener noreferrer">
            {intl.formatMessage(messages.findOutMore)}
          </Button>
        </div>
      </div>
    </Modal>
  );

  return (
    <div className="message-board-container tile-border">
      <h3>{intl.formatMessage(messages.usefulProductsForYou)}</h3>

      <div className="message-content">
        <button className="message-board-icon" onClick={goToPreviousMessage}>
          <LeftIcon className="message-board-arrow-icon" />
        </button>
        <div className="message-description">
          <article className="promoPP promoPP--alternate">
            <figure>
              <img alt={currentAd.title} src={currentAd.imageURL} />
            </figure>
            <aside>
              <strong dangerouslySetInnerHTML={{ __html: currentAd.title }} />
              <div className="promo-description-container">
                <p
                  ref={descriptionRef}
                  className="promo-description"
                  dangerouslySetInnerHTML={{ __html: currentAd.description }}
                />
                {isOverflowing && (
                  <button className="link read-more-link" onClick={handleReadMore}>
                    {intl.formatMessage(messages.readMore)}
                  </button>
                )}
              </div>
              <Button href={currentAd.productURL} target="_blank" rel="noopener noreferrer">
                {intl.formatMessage(messages.findOutMore)}
              </Button>
            </aside>
          </article>
        </div>
        <button className="message-board-icon" onClick={goToNextMessage}>
          <RightIcon className="message-board-arrow-icon" />
        </button>
      </div>

      <div className="dot-container">
        {insuranceAdsData.map((ad, index) => (
          <button
            key={ad.title}
            className={`dot ${index === insuranceAdsIndex ? "active-dot" : "inactive-dot"}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>

      {InsuranceAdModal}
    </div>
  );
};

InsuranceAdsPP.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(InsuranceAdsPP);



// WEBPACK FOOTER //
// ./components/dashboard/DashboardNewUI/InsuranceAdsPP.js